import { render } from "./ConfirmEvent.vue?vue&type=template&id=36365fde"
import script from "./ConfirmEvent.vue?vue&type=script&lang=js"
export * from "./ConfirmEvent.vue?vue&type=script&lang=js"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__